import PropTypes from 'prop-types';
import Autocomplete from '../../../../../component/common/Autocomplete';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { FIELD_CLASS, FIELD_LABEL_CLASS } from '../../../../../component/common/StandardUI';

const MultiSelectField = ({
  label,
  placeholder,
  options,
  loading,
  onSearch,
  selectedItems,
  onChange,
  error,
  required
}) => {
  const availableOptions = options.filter(
    (option) => !selectedItems.some((item) => item._id === option._id)
  );

  const handleSelect = (option) => {
    onChange([...selectedItems, option]);
  };

  const handleRemove = (id) => {
    onChange(selectedItems.filter((item) => item._id !== id));
  };

  return (
    <div>
      <Autocomplete
        label={label}
        placeholder={placeholder}
        options={availableOptions}
        onSearch={onSearch}
        onSelect={handleSelect}
        loading={loading}
        required={required}
        error={error}
        inputClassName={FIELD_CLASS}
        labelClassName={`${FIELD_LABEL_CLASS} mb-1`}
      />
      {selectedItems.length > 0 && (
        <div className="flex flex-wrap gap-2 mt-2">
          {selectedItems.map((item) => (
            <span
              key={item._id}
              className="inline-flex items-center gap-1 bg-shoorah-inputBackground dark:bg-gray-700 text-gray-700 dark:text-gray-200 text-xs px-3 py-1 rounded-full"
            >
              {item.name}
              <XMarkIcon
                className="w-3.5 h-3.5 cursor-pointer"
                onClick={() => handleRemove(item._id)}
              />
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

MultiSelectField.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  options: PropTypes.array.isRequired,
  loading: PropTypes.bool,
  onSearch: PropTypes.func.isRequired,
  selectedItems: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string,
  required: PropTypes.bool
};

export default MultiSelectField;
